import { createSelector } from "@reduxjs/toolkit";

import getModeLights from "./get-mode-lights";

export default createSelector(
    getModeLights,
    ({ map }) => map.general.selectedLights,
    (lights, selectedLights) => {
        const selected = [];
        selectedLights.forEach((selectedKey) => {
            if (lights[selectedKey]) {
                selected.push(lights[selectedKey]);
            }
        });
        return selected;
    },
);
